module.exports = __webpack_public_path__ + "static/media/sort.cb05755b.svg";